import axios from "axios";
import { safeStorage } from "../utils/safeStorage";
export const loggedUser = async (currentPage) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASEURL}/api/user/loggedUser/detail?page=${currentPage}&size=${10}`, {
            headers: {
                "x-access-token": safeStorage.getItem("token")
            }
        });
        return response;
    }catch(err){
        return err.message
    }
}